import { gql } from '@apollo/client'
import { GraphQLContext } from '@moonpig/web-core-graphql'
import { logger } from '@moonpig/web-core-monitoring'
import { CustomerSegment } from '@moonpig/web-core-types-graphql'
import { EppoClient } from '@moonpig/web-core-eppo/server'
import { getCookie } from '@moonpig/web-core-browser-storage'
import { NextPageContext } from 'next'
import { CustomerSegmentQuery } from '../__generated__/getInitialProps'

type GetCustomerSegmentsArgs = {
  isBot?: boolean
  graphQLContext: GraphQLContext
  eppoClient: EppoClient | null
  subjectKey: string
  nextPageContext: NextPageContext
}

type GetCustomerSegments = (
  args: GetCustomerSegmentsArgs,
) => Promise<Array<CustomerSegment>>

type FetchNonCachedCustomerSegmentsArgs = {
  graphQLContext: GraphQLContext
}

const fetchNonCachedCustomerSegments = async ({
  graphQLContext: { query },
}: FetchNonCachedCustomerSegmentsArgs) => {
  try {
    const { data } = await query<CustomerSegmentQuery, Record<string, unknown>>(
      {
        query: gql`
          query CustomerSegmentQuery {
            me {
              segments
            }
          }
        `,
      },
    )

    const customerSegments = data.me.segments ?? []

    logger.info(`customerSegments: ${JSON.stringify(customerSegments)}`)
    return customerSegments
  } catch (error) {
    logger.warning(`Error fetching customer segment data: ${error.message}`)
    return []
  }
}

export const getCustomerSegments: GetCustomerSegments = async ({
  isBot = false,
  graphQLContext,
  eppoClient,
  subjectKey,
  nextPageContext,
}) => {
  const isEnabled = eppoClient?.getBooleanAssignment(
    'enable-segments-query',
    subjectKey,
    {},
    false,
  )

  if (isBot || !isEnabled) return []

  const cachedSegments = getCookie(nextPageContext, 'mnpg_customer_segments')
  if (cachedSegments) {
    return JSON.parse(cachedSegments) as Array<CustomerSegment>
  }

  const segments = await fetchNonCachedCustomerSegments({ graphQLContext })

  return segments
}
